'use strict';

var React = require('react');
var Link = require('react-router').Link;
var RouteConstants = require('../constants/RouteConstants');
import Footer from './Footer.jsx';
import ContentService from './../services/ContentService.js';
import ApplicationStore from './../stores/ApplicationStore.js';
import FooterUtil from './../utils/FooterHelper'; 
import OmnitureTracking from '../utils/OmnitureTracking.js'
function getInvestorTypeState() {
    return {
        content: ContentService.getContent(),    
        productId: ApplicationStore.getProductId()
    };
}

var InvestorType = React.createClass({
    getInitialState: function () {
        return getInvestorTypeState();
    },
    
    componentDidMount: function () {
        OmnitureTracking.getTrackingEnabled();
    },
    
    render: function () {
        const footerContent = FooterUtil.getContent(this.state.productId, this.state.content);

        return (
            <div className="start">
                <div className="container">
                    <h2>How would you like to begin?</h2>
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4">
                            <p><Link to={RouteConstants.ClientApplication} className="btn btn-default btn-block btn-lg">I am a new investor</Link></p>
                            <p><a href={window.NOA.configuration.firstNetLoginUrl} className="btn btn-default btn-block btn-lg" target="_self">I am an existing investor</a></p>
                        </div>
                    </div>
                </div>
                <Footer content={footerContent} />
            </div>
        );
    }
});

module.exports = InvestorType;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/InvestorType.jsx